/* eslint-disable prettier/prettier */
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { ICON, RADIUS, SURFACE, TEXT } from '../theme/tokens'

const Notice = ({ notices = [] }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {notices.map((notice, index) => (
            <Box
                key={index}
                sx={{
                    display: 'flex',
                    gap: 1,
                    p: '10px 12px',
                    border: `1px solid ${SURFACE.border}`,
                    borderRadius: `${RADIUS.sm}px`,
                    backgroundColor: SURFACE.inputBg,
                }}
            >
                <InfoOutlinedIcon
                    sx={{
                        fontSize: ICON.sm,
                        color: TEXT.muted,
                        mt: '2px',
                        flexShrink: 0,
                    }}
                />
                <Typography variant="caption" sx={{ color: TEXT.muted }}>
                    {notice}
                </Typography>
            </Box>
        ))}
    </Box>
)

Notice.propTypes = {
    notices: PropTypes.array,
}

export default Notice
